/** Narrows the `assetsVertical_tenantContext` union to the workspace ARI. */
export const extractWorkspaceAri = (
	tenantContext:
		| {
				readonly __typename: string;
				readonly tenantContext?: {
					readonly assetsVerticalWorkspaceAri?: string | null;
				} | null;
		  }
		| null
		| undefined,
): string | null =>
	tenantContext?.__typename === 'AssetsVerticalTenantContextSuccess'
		? (tenantContext.tenantContext?.assetsVerticalWorkspaceAri ?? null)
		: null;
